'use client';

import { useContext, useEffect, useState } from 'react';
import { AppStoreContext, useStore } from '@/providers/app-store-provider';
import { ResponsiveContext } from '@/components/Responsive/ResponsiveProvider';
import { EPlatform } from '@/utils/enums/platform-enum';
import { env } from '@/utils/env';
import { resolveBrowserCartExperiment } from './client';
import { getCartSitePolicy } from './index';
import type { CartExperimentState } from './types';

export function useCartSitePolicy() {
  const store = useContext(AppStoreContext);
  const { deviceType } = useContext(ResponsiveContext);
  const token = useStore((state) => state.token || '');
  const [resolved, setResolved] = useState<{ token: string; state: CartExperimentState }>();
  const supported = deviceType === EPlatform.WEB || deviceType === EPlatform.WAP;
  const remote = supported && env.NEXT_PUBLIC_SITE_NAME === 'us';

  useEffect(() => {
    if (!remote || !store) return;
    let active = true;
    void resolveBrowserCartExperiment(store).then((state) => {
      if (active) setResolved({ token, state });
    });
    return () => {
      active = false;
    };
  }, [store, remote, token]);

  const state = remote
    ? resolved?.token === token
      ? resolved.state
      : undefined
    : ({ status: 'disabled' } as const);
  const ready = !remote || (!!state && state.status !== 'idle' && state.status !== 'loading');
  const policy = supported
    ? getCartSitePolicy(env.NEXT_PUBLIC_SITE_NAME, state ?? { status: 'idle' })
    : ({ experience: 'legacy', couponPolicy: 'manual' } as const);
  return { ready, policy };
}
